const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform)

export const MODIFIER_KEY: 'meta' | 'ctrl' = isMac ? 'meta' : 'ctrl'
export const MODIFIER_KEY_NAME: 'Meta' | 'Control' = isMac ? 'Meta' : 'Control'
export const MODIFIER_LABEL: '⌘' | 'Ctrl' = isMac ? '⌘' : 'Ctrl'
export const MODIFIER_HELD_CLASS = 'modifier-held'

export function isModifierPressed(event: { metaKey: boolean; ctrlKey: boolean }): boolean {
  return MODIFIER_KEY === 'meta' ? event.metaKey : event.ctrlKey
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const setHeld = (held: boolean) => {
    document.body.classList.toggle(MODIFIER_HELD_CLASS, held)
  }
  window.addEventListener('keydown', (e) => {
    if (e.key === MODIFIER_KEY_NAME) setHeld(true)
  })
  window.addEventListener('keyup', (e) => {
    if (e.key === MODIFIER_KEY_NAME) setHeld(false)
  })
  window.addEventListener('blur', () => setHeld(false))
}
